<template>
  <div class="find-pas container" :class="{height:codeshow}">
    <div class="wrapper">
      <a class="logo" href="http://www.tuling123.com/"></a>
      <div class="con-wrap">
        <div class="tit-box">
          <p class="tit active">
            第三方登录
          </p>
        </div>
        <div class="wrong" :class="{active:errorMsg!==''}">{{errorMsg}}</div>
        <div>
          <div class="wx-name">{{userName}}</div>
             <input type="text" class="cal" v-model="telphone" placeholder="手机号码" maxlength="11">
             <div class="yz">
               <input type="text" class="yz-inp" v-model="code"  placeholder="短信验证码" maxlength="8" @keyup.enter="sendyzm">
               <button class="sent yz-btn" @click="sendyzm" >{{sendMsg}}</button>
             </div>
              <div class="jtocode" v-show="codeshow" ref="jcode"></div>
             <div class="login-btn" @click="submit">绑定并登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../js/geetest.js';
  import mixin from '../../js/public.js';
  import $ from 'jquery';
  export default{
    mixins: [mixin],
    data () {
        return {
          show: false,
          errorMsg: '该账号尚绑定手机号，快速绑定并登录',
          telphone: '',
          code: '',
          id: '',
          codeshow: false,
          sendMsg: '发送验证码',
          type: '',
          userName: ''
        };
      },
      created () {
        this.id = this.uuid();
        this.type = this.$route.query.type;
        this.userName = this.$route.query.name;
        this.$nextTick(function () {
          document.getElementsByTagName('title')[0].innerHTML = '第三方登录';
        });
      },
      methods: {
        changePage (n) {
          this.page = n;
          this.codeshow = false;
          this.errorMsg = '';
        },
        getJy () {
          var _this = this;
          if (this.$refs.jcode.innerHTML) {
            return;
          }
          $.ajax({
            url: _this.baseUrl + '/geetest/v3',
            type: 'POST',
            dataType: 'json',
            data: {id: _this.id},
            xhrFields: {
              withCredentials: true
            },
            success: function (res) {
              if (res.type === 'success') {
                window.initGeetest({
                  gt: res.data.gt,
                  challenge: res.data.challenge,
                  new_captcha: res.data.new_captcha,
                  product: 'popup',
                  width: '100%',
                  offline: !res.data.success
                }, _this.handlerPopup);
              }
            }
          });
        },
        uuid () {
          function S4 () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        },
        handlerPopup (captchaObj) {
          var _this = this;
          captchaObj.appendTo('.jtocode');
          captchaObj.onReady(function () {
            setTimeout(function () {
              document.getElementsByClassName('geetest_radar_btn')[0].click();
            }, 16);
          });
          captchaObj.onSuccess(function () {
            var validate = captchaObj.getValidate();
            _this.errorMsg = '';
            setTimeout(function () {
              _this.codeshow = false;
            }, 1500);
            _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.telphone}).then(function (res) {
              if (res.body.type === 'success') {
                  $.ajax({
                    url: _this.baseUrl + '/register/semd/4',
                    type: 'POST',
                    dataType: 'json',
                    data: {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone},
                    xhrFields: {
                      withCredentials: true
                    },
                    success: function (data) {
                      if (data.type === 'success') {
                        _this.errorMsg = '';
                        _this.toCode();
                        captchaObj.reset();
                      } else {
                        _this.errorMsg = '操作频繁，请稍后再试';
                      }
                    }
                  });
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
            });
          });
        },
        toCode () {
          var _this = this;
          var i = 60;
          this.sendMsg = i + '秒';
            var nu = setInterval(function () {
              i--;
              _this.sendMsg = i + '秒';
              if (i === 0) {
                clearInterval(nu);
                _this.sendMsg = '发送验证码';
              }
            }, 1000);
        },
        sendyzm () {
          var phonetest = /^1[0-9]{10}$/;
          var _this = this;
          if (this.sendMsg.length !== 5) {
            return;
          }
          if (!phonetest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码';
            return;
          }
          //  是否需要极验
          this.$http.post(_this.baseUrl + '/common/need-verify', {mobile: _this.telphone}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              if (res.body.data) {
                this.getJy();
                this.codeshow = true;
                this.errorMsg = '请进行图片验证';
              } else {
                //  发送验证码
                $.ajax({
                  url: _this.baseUrl + '/register/semd/3',
                  type: 'POST',
                  dataType: 'json',
                  data: {mobile: _this.telphone},
                  xhrFields: {
                    withCredentials: true
                  },
                  success: function (data) {
                    if (data.type === 'success') {
                      _this.errorMsg = '';
                      _this.toCode();
                    } else {
                      _this.errorMsg = '操作频繁，请稍后再试';
                    }
                  }
                });
              }
            } else {
              this.errorMsg = '网络繁忙，请稍后重试';
            }
          });
        },
        submit () {
          var _this = this;
          var phonetest = /^1[0-9]{10}$/;
          var re = /^\d+$/;
          var re1 = /^[a-zA-Z]+$/;
          var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
          if (!phonetest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码';
            return;
          }
          if (!this.code) {
            this.errorMsg = '验证码不能为空';
            return;
          }
          this.errorMsg = '';
          /* 判断手机号、验证码是否正确 */
          _this.$http.post(_this.baseUrl + '/register/validate/1', {mobile: _this.telphone, code: _this.code}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              /* 提交信息 */
              var url = _this.baseUrl + '/register/save/3';
              _this.$http.post(url, {
                mobile: _this.telphone,
                code: _this.code,
                auto_login: true,
                redirect_uri: '',
                register_from: {qq: 1, bo: 2, wei: 3}[this.type],
                referer: _this.ReturnURl
              }, {credentials: true}).then(function (res) {
                if (res.body.type === 'success') {
                  _this.show = true;
                  window.location = _this.ReturnURl;
                } else {
                  _this.errorMsg = '验证码错误';
                }
              }, function () {
                _this.errorMsg = '网络错误，请稍后重试';
              });
            } else {
              _this.errorMsg = '验证码错误';
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
          });
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  @import "../../css/public.scss";
  .tit-box{
    display: block;
  }
  .tit{
    margin-left: 20px;
    height: 50px;
  }
  .find-pas{
    height: 540px;
  }
  .find-pas.height{
    height: 590px;
  }
</style>



// WEBPACK FOOTER //
// third.vue?6df203f8